import useResizeObserver from '@react-hook/resize-observer'
import { debounce, isEqual } from 'lodash'
import { useMemo, useRef, useState } from 'react'

export const useResizeBaseAssetsList = () => {
  const assetsListRef = useRef(null)
  const assetListHeaderRef = useRef(null)
  const [ assetsListSize, setAssetsListSize ] = useState({ width: 0, height: 0 })
  const [ assetListHeaderSize, setAssetsListHeaderSize ] = useState({ width: 0, height: 0 })

  const setListSize = useMemo(() => {
    const updateSize = debounce(entries => {
      if (!entries) return
      const { contentRect } = entries
      const newData = {
        width: contentRect.width,
        height: contentRect.height,
      }
      setAssetsListSize(prev => {
        if (!isEqual(prev, newData)) {
          return newData
        }
        return prev
      })
    }, 300)
    return updateSize
  }, [ setAssetsListSize ])

  const setListHeaderSize = useMemo(() => {
    const updateSize = debounce(entries => {
      if (!entries) return
      const { contentRect } = entries
      const newData = {
        width: contentRect.width,
        height: contentRect.height,
      }
      setAssetsListHeaderSize(prev => {
        if (!isEqual(prev, newData)) {
          return newData
        }
        return prev
      })
    }, 300)
    return updateSize
  }, [ setAssetsListHeaderSize ])

  useResizeObserver(assetsListRef, setListSize)
  useResizeObserver(assetListHeaderRef, setListHeaderSize)

  return {
    assetsListSize,
    assetListHeaderSize,
    assetsListRef,
    assetListHeaderRef,
  }
}
